import React, { Suspense, useState } from "react";
import { Route, Switch } from "react-router-dom";
import { LoadingFallback } from "components/LoadingFallback";
import RoleOperadorService, { OperadorData } from "services/axios/role_operador/RoleOperadorService";
import { useDialog } from "muibox";
import { mensajesGenerales } from "config/mensajes";
import { defaultAlertOptions } from "config/muibox";

const DashboardPage = React.lazy(() => import('pages/role_operador/dashboard/DashboardPage'));
const DetalleServicioPage = React.lazy(() => import('pages/role_operador/servicios/DetalleServicioPage'));
interface OperadorDataContext {
  operadorData: OperadorData | null;
  setOperadorData: (operadorData: OperadorData) => void;
}

export const OperadorDataContext = React.createContext<OperadorDataContext | null>(null);

const mensajes = {
  ...mensajesGenerales,
}

export default () => {
  const dialog = useDialog();
  const [operadorData, setOperadorData] = useState<OperadorData | null>(null);
  const contextValue = { operadorData, setOperadorData }; //se usa esto para poder actualizarlo desde un child

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const _operadorData = await RoleOperadorService.fetchOperadorData();
        setOperadorData(_operadorData);
      } catch (error) {
        error && //if not cancelled 
          dialog.alert({
            ...defaultAlertOptions,
            title: mensajes.formValidacion.haOcurridoUnError,
            message: `${error.message}`
          });
      }
    }
    fetchData();
  }, [dialog]);


  return (
    <Suspense fallback={<LoadingFallback backgroundColor="#ebebeb" />}>
      <OperadorDataContext.Provider value={contextValue}>
        <Switch>
          <Route path="/" exact component={DashboardPage} />
          <Route path="/operador/" exact component={DashboardPage} />
          <Route path="/operador/dashboard" component={DashboardPage} />
          <Route path="/operador/servicios/:id" component={DetalleServicioPage} exact />
        </Switch>
      </OperadorDataContext.Provider>
    </Suspense>
  )
}
